import { render, staticRenderFns } from "./ComponentStatic.vue?vue&type=template&id=f46ab0be&scoped=true"
import script from "./ComponentStatic.vue?vue&type=script&lang=js"
export * from "./ComponentStatic.vue?vue&type=script&lang=js"
import style0 from "./ComponentStatic.vue?vue&type=style&index=0&id=f46ab0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46ab0be",
  null
  
)

export default component.exports